import { render, staticRenderFns } from "./barkeGoods.vue?vue&type=template&id=605f6f36&scoped=true&"
import script from "./barkeGoods.vue?vue&type=script&lang=js&"
export * from "./barkeGoods.vue?vue&type=script&lang=js&"
import style0 from "./barkeGoods.vue?vue&type=style&index=0&id=605f6f36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f6f36",
  null
  
)

export default component.exports